import { get, IResponseError, post } from 'communication/httpClient';
import {
  LOAD_PRODUCTS,
  LOAD_PRODUCTS_BY_IDS,
  PRODUCTS_LOADED,
  PRODUCTS_BY_IDS_LOADED,
  SEARCH_PRODUCTS,
  SEARCH_PRODUCTS_LOADED,
  SYNC_FAILED,
  RESET_PRODUCTS,
  RESET_SEARCH_PRODUCTS,
  LOAD_PRODUCTS_ATTRIBUTES,
  PRODUCTS_ATTRIBUTES_LOADED,
} from './actionTypes';
import { IProductAttributes, IProductCodes } from './types';

export const initialActionsState = {
  loadProducts: () => {},
  loadProductsByIds: (productIds: string[]) => {},
  loadProductsAttributes: (
    itemsData: IProductCodes,
    onSuccess?: (productsAttributes?: IProductAttributes) => void
  ) => {},
  searchProducts: () => {},
  resetProducts: () => {},
  resetSearchProducts: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadProducts: async () => {
    dispatch({
      type: LOAD_PRODUCTS,
    });
    const { data, error } = await get('/api/catalog/items');

    if (data && data.items) {
      dispatch({
        type: PRODUCTS_LOADED,
        payload: data.items,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadProductsByIds: async (productIds: string[]) => {
    dispatch({
      type: LOAD_PRODUCTS_BY_IDS,
    });
    const promises = productIds.map((id) => get(`/api/catalog/items/${id}`));
    let error:IResponseError|null = null;
    const results = await Promise.all(promises);
    for(const result of results){
      if(result?.error && result.error.status >= 500){
        error = result?.error
        break;
      }
    }
    dispatch({
      type: PRODUCTS_BY_IDS_LOADED,
      payload: { data : results.map((res) => res.data),error }
    });
  },
  loadProductsAttributes: async (
    productsCodeData: IProductCodes,
    onSuccess?: (productsAttributes?: IProductAttributes) => void
  ) => {
    dispatch({
      type: LOAD_PRODUCTS_ATTRIBUTES,
    });
    const { data, error } = await post('/api/catalog/items', productsCodeData);
    if (onSuccess) onSuccess(data || {});

    if (!error && data) {
      dispatch({
        type: PRODUCTS_ATTRIBUTES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  searchProducts: async (searchTerm: string, exact: boolean, categoryId: string) => {
    dispatch({
      type: SEARCH_PRODUCTS,
    });
    const { data, error } = await get(
      '/api/catalog/items?searchText=' +
        searchTerm +
        '&exact=' +
        exact +
        '&categoryId=' +
        categoryId
    );

    if (data) {
      dispatch({
        type: SEARCH_PRODUCTS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetProducts: () =>
    dispatch({
      type: RESET_PRODUCTS,
    }),
  resetSearchProducts: () =>
    dispatch({
      type: RESET_SEARCH_PRODUCTS,
    }),
});
